<script lang="ts">
export interface BreadcrumbItem {
  label: string;
  to?: string | RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric;
  icon?: string;
  iconColor?: string;
}
</script>

<script setup lang="ts">
import type { RouteLocationAsPathGeneric, RouteLocationAsRelativeGeneric } from "vue-router";

const props = defineProps<{
  items: BreadcrumbItem[];
}>();
</script>

<template>
  <div class="breadcrumb">
    <div
      v-for="item in props.items"
      :key="item.label"
      class="item"
      :class="{ 'has-link': item.to !== undefined }"
    >
      <i
        v-if="item.icon !== undefined"
        class="icon"
        :class="item.icon"
        :style="`color: ${item.iconColor}`"
      />
      <RouterLink v-if="item.to !== undefined" :to="item.to">
        {{ item.label }}
      </RouterLink>
      <span v-else>{{ item.label }}</span>
    </div>
  </div>
</template>

<style scoped>
.breadcrumb {
  display: flex;

  .item {
    margin-right: var(--spacing-8);
    color: var(--color-text-secondary);

    .icon {
      margin-right: var(--spacing-4);
      vertical-align: middle;
    }

    a {
      color: inherit;
      text-decoration: none;
    }

    &::before {
      margin-right: var(--spacing-8);
      color: var(--color-text-secondary);
      content: "/";
    }

    &:last-child {
      color: var(--color-text-primary);
    }
  }
}
</style>
